import Vue from 'vue';

function renderdStackableTable (table) {
    const rows = table.querySelectorAll('tbody > tr');
    const headerLabels = Array.from(table.querySelectorAll('thead > tr > th'))
        .map(th => th.innerText || th.textContent);

    rows.forEach(row => {
        const columns = row.querySelectorAll('td');
        columns.forEach((column, index) => {
            const oldLabel = column.querySelector('.stackable-table-label');
            if (oldLabel) {
                return;
            }

            if (column.childNodes.length === 1 && column.childNodes[0].tagName === 'DIV') {
                const div = column.childNodes[0];
                div.className += 'stackable-table-content';
            }

            const label = document.createElement('div');
            label.className = 'stackable-table-label';
            label.innerHTML = headerLabels[index];
            column.prepend(label);
        });
    });
}

Vue.directive('stackable-table', {
    bind (el, binding) {
        if (binding.value === null || binding.value === false) {
            return;
        }

        const table = el;
        // Add the stackable class name
        table.className += ' stackable-table';

        renderdStackableTable(table);
    },

    componentUpdated (el, binding) {
        if (binding.value === null || binding.value === false) {
            return;
        }

        const table = el;
        renderdStackableTable(table);
    },
});

Vue.directive('click-outside', {
    bind (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (! (el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
});
